import { css } from '@emotion/css';
import { tabStyle,repeaterPaneStyle } from 'Shared/backend/contact/ContactPage';
import { theme } from 'Shared/backend/ThemeProvider';
import { Checkbox, SingleSelect, Text } from 'Shared/forms/Inputs';
import { addItemAndOpen, StoreRepeater } from 'Shared/forms/StoreRepeater';
import { LabelOnLeftWrap, Wrap } from 'Shared/forms/Wrap';
import { emailTypes } from 'Shared/common/emailTypes';
import { Show } from 'solid-js';


export function EmailsTab(props)
{
	let emailsNode;

	const title = i => {
		let ret = i.type=='custom' ? (i.customLabel ?? '') : emailTypes[i.type];
		if (i.email)
			ret += ': ' + i.email;
		return ret;
	};

	return (
		<div class={tabStyle()}>
			<h3 class={css(theme().section.blueHeading)}>Contact emails</h3>

			The first listed below will appear as the 'primary email' on your website and google search

			<br/>

			<StoreRepeater ref={emailsNode} {...props} page={props.page} field='email' 
				renderTitle={i => title(i)}
			>
				{(item,index) => <Email {...props} {...item} location={['email',index]} index={index} />}
			</StoreRepeater>

			<button class={css(theme().button,{alignSelf:'start'})}
				onClick={() => addItemAndOpen({...props,permission:'edit',field:'email'},emailsNode,{})}
			>
				<i class='fas fa-plus'/> Add social media
			</button>
		</div>
	);
}

function Email(props)
{
	return (
		<div class={repeaterPaneStyle()}>
			<Wrap label='Email purpose'>
				<SingleSelect {...props} field='type' options={emailTypes} />
			</Wrap>

			<Show when={props.type=='custom'}>
				<Wrap label='Other purpose for email'>
					<Text {...props} field='customLabel' />
				</Wrap>
			</Show>

			<Wrap label='Email Address'>
				<Text {...props} field='email' />
			</Wrap>

			<Wrap label='Optional tips/description'>
				<Text {...props} field='tips' />
			</Wrap>

			<LabelOnLeftWrap label='Primary email'
				notes='Display prominently on website navigation and search engines'
			>
				<Checkbox {...props} field='primary' />
			</LabelOnLeftWrap>
		</div>
	);
}
